module.exports = __webpack_public_path__ + "static/media/GongGothicBold.07bd8dd9.ttf";